<script setup lang="ts">
import type { SuggestionItem } from '@optionway/models';

defineProps<{ suggestion: SuggestionItem; query: string }>();

const prefix = 'components.search.autocompleteInput';
</script>

<template>
  <div
    class="flex items-center gap-3"
    :class="{ 'pl-8': suggestion.type === 'airport' || suggestion.type === 'train' }"
  >
    <div class="mt-0.5 shrink-0 text-xl text-text-primary-900">
      <SvgoSearchPlane
        v-if="suggestion.type === 'airport'"
        filled
      />
      <SvgoSearchTrain
        v-else-if="suggestion.type === 'train'"
        filled
      />
      <SvgoSearchBuilding
        v-else
        filled
      />
    </div>

    <div class="flex flex-col text-left">
      <template
        v-if="
          suggestion.type === 'city' || suggestion.type === 'cityWithTrain' || suggestion.type === 'citySameAirport'
        "
      >
        <div class="text-base text-text-primary-900">
          <SearchHighlightText
            :text="suggestion.cityLabel ?? ''"
            :query="query"
          />,
          <SearchHighlightText
            :text="suggestion.countryLabel ?? ''"
            :query="query"
          />
          (<SearchHighlightText
            :text="suggestion.code ?? ''"
            :query="query"
          />)
        </div>
        <div class="text-xs text-text-primary-900">
          <template v-if="suggestion.type === 'citySameAirport'">
            <SearchHighlightText
              :text="$t(`${prefix}.citySameAirport`, { airport: suggestion.airportLabel })"
              :query="query"
            />
          </template>
          <template v-else>
            {{ $t(`${prefix}.allAirports`) }}
            <span v-if="suggestion.type === 'cityWithTrain'">{{ $t(`${prefix}.withTrains`) }}</span>
          </template>
        </div>
      </template>

      <template v-else>
        <div class="text-text-primary-900">
          <SearchHighlightText
            v-if="suggestion.type === 'airport'"
            :text="
              $t(`${prefix}.airportItem`, {
                city: suggestion.cityLabel,
                airport: suggestion.airportLabel,
                code: suggestion.code,
              })
            "
            :query="query"
          />
          <SearchHighlightText
            v-else-if="suggestion.type === 'train'"
            :text="
              $t(`${prefix}.trainItem`, {
                city: suggestion.cityLabel,
                train: suggestion.airportLabel,
                code: suggestion.code,
              })
            "
            :query="query"
          />
        </div>
        <div class="text-xs text-text-primary-900">
          <SearchHighlightText
            :text="suggestion.cityLabel ?? ''"
            :query="query"
          />,
          <SearchHighlightText
            :text="suggestion.countryLabel ?? ''"
            :query="query"
          />
        </div>
      </template>
    </div>
  </div>
</template>
